export const environment = {
  production: false,
  name: 'development',
  hash: new Date().toISOString().replace(/\.|:|-/g,'')
};
